<template>
    <main>

        <div class="login-body">

            <div class="login-background">
                
                <picture class="login-background">
                  <source srcset="/images/company-portal/login-background.webp" type="image/webp">
                  <source srcset="/images/company-portal/login-background.jpg" type="image/jpg"> 
                  <img src="/images/company-portal/login-background.jpg" class="login-background">
                </picture>

            </div>

            <img class="login-branding" src="/images/company-portal/logo.svg">

            <div class="login-window">

                <h1>Företag</h1>

                <form @submit.prevent="posterPost">

                    <div class="login-form" :class="{ 'loading' : poster.submitted }">
                        <input-text
                            type="email"
                            name="email"
                            label="E-postadress"
                            :form-group-class="['mb-0', {'is-invalid': poster.unhandled_error}]"
                            v-model="email"
                            :float-label="true"
                            custom-error-message=" "
                        />
                        <div class="separator"><div class="separator-line"></div></div>
                        <input-text
                            type="password"
                            name="password"
                            label="Lösenord"
                            form-group-class="mb-0"
                            v-model="password"
                            :float-label="true"
                        />
                        <div class="invalid-feedback">
                            E-postadressen och lösenordet stämmer inte överens. Vänligen försök igen.
                        </div>
                        <div class="loader"><div class="spinner"></div></div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-12 d-flex align-items-center">
                            <router-link to="/password/email" style="font-size: 14px;">Glömt lösenordet?</router-link>
                        </div>
                        <div class="col-12 d-flex justify-content-end">
                            <button type="submit" class="btn btn-primary" :disabled="poster.submitted">
                                Logga in
                            </button>
                        </div>
                    </div>
                </form>
            </div>

        </div>

    </main>
</template>

<script>

import poster from '../../../shared/mixins/poster'

export default {

    mixins: [
        poster
    ],

    data () {
        return {
            email: '',
            password: ''
        }
    },

    computed: {
        posterUrl () {
            return '/login'
        },
        posterData () {
            return {
                email: this.email,
                password: this.password
            }
        }
    },

    methods: {
        posterSuccess () {
            window.location.href = '/'
        }
    }

}
</script>
